(function () {
  function getScope(root) {
    return root && root.querySelector && root.querySelector('[data-pb-trust-funnel-v1]') ? root : null;
  }

  function readOfferQuantity(scope) {
    var activeOffer = scope.querySelector('[data-pb-offer-card].is-selected, [data-pb-offer-card].active');
    if (activeOffer && activeOffer.dataset.qty) {
      var offerQty = parseInt(activeOffer.dataset.qty, 10);
      if (!Number.isNaN(offerQty) && offerQty > 0) return offerQty;
    }

    var active = scope.querySelector('.pb-sel-pill.active');
    if (active && active.id) {
      var match = active.id.match(/card-qty-(\d+)/);
      if (match) return parseInt(match[1], 10);
    }

    var source = scope.querySelector('#pb-final-val');
    if (source) {
      var parsed = parseInt(source.value, 10);
      if (!Number.isNaN(parsed) && parsed > 0) return parsed;
    }

    var customQuantity = parseInt(window.CUSTOM_QUANTITY, 10);
    if (!Number.isNaN(customQuantity) && customQuantity > 0) return customQuantity;
    return 1;
  }

  function parseRomanianMoney(text) {
    var normalized = String(text || '')
      .replace(/[^\d,.]/g, '')
      .replace(/\./g, '')
      .replace(',', '.');
    var value = parseFloat(normalized);
    return Number.isNaN(value) ? 0 : value;
  }

  function readUnitPrice(scope) {
    var selector = scope.querySelector('[data-pb-offer-selector]');
    var unitPriceCents = selector ? parseInt(selector.dataset.unitPriceCents, 10) : 0;
    if (!Number.isNaN(unitPriceCents) && unitPriceCents > 0) return unitPriceCents / 100;

    var total = scope.querySelector('#pb-total-price');
    var totalValue = total ? parseRomanianMoney(total.textContent) : 0;
    if (totalValue > 0) return totalValue;

    var salePrice = scope.querySelector('.price-item--sale, .price-item--regular');
    var saleValue = salePrice ? parseRomanianMoney(salePrice.textContent) : 0;
    return saleValue > 0 ? saleValue : 0;
  }

  function formatLei(value) {
    return value.toLocaleString('ro-RO', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }) + ' lei';
  }

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function runOfferBurst(selector, event) {
    if (!selector || prefersReducedMotion()) return;

    var canvas = selector.querySelector('#pb-particles-cv');
    if (!canvas || !canvas.getContext) return;

    var context = canvas.getContext('2d');
    var rect = selector.getBoundingClientRect();
    var targetRect = event && event.target && event.target.getBoundingClientRect ? event.target.getBoundingClientRect() : null;
    var x = event && event.clientX ? event.clientX - rect.left : targetRect ? targetRect.left + targetRect.width / 2 - rect.left : rect.width / 2;
    var y = event && event.clientY ? event.clientY - rect.top : targetRect ? targetRect.top + targetRect.height / 2 - rect.top : 64;
    var ratio = window.devicePixelRatio || 1;

    canvas.width = Math.max(1, Math.round(rect.width * ratio));
    canvas.height = Math.max(1, Math.round(rect.height * ratio));
    canvas.style.width = rect.width + 'px';
    canvas.style.height = rect.height + 'px';
    context.setTransform(ratio, 0, 0, ratio, 0, 0);

    var particles = Array.from({ length: 16 }, function () {
      var angle = Math.random() * Math.PI * 2;
      var speed = Math.random() * 2.4 + 1.2;
      return {
        x: x,
        y: y,
        vx: Math.cos(angle) * speed,
        vy: Math.sin(angle) * speed,
        size: Math.random() * 2.6 + 1.6,
        life: 1,
        color: Math.random() > 0.46 ? '#2ab39e' : '#0d6e56'
      };
    });

    var draw = function () {
      context.clearRect(0, 0, rect.width, rect.height);
      var alive = false;

      particles.forEach(function (particle) {
        if (particle.life <= 0) return;
        alive = true;
        particle.x += particle.vx;
        particle.y += particle.vy;
        particle.vy += 0.055;
        particle.life -= 0.035;

        context.globalAlpha = Math.max(0, particle.life);
        context.fillStyle = particle.color;
        context.beginPath();
        context.arc(particle.x, particle.y, particle.size, 0, Math.PI * 2);
        context.fill();
      });

      context.globalAlpha = 1;
      if (alive) {
        window.requestAnimationFrame(draw);
      } else {
        context.clearRect(0, 0, rect.width, rect.height);
      }
    };

    draw();
  }

  function ensureOfferController(scope) {
    var selector = scope.querySelector('[data-pb-offer-selector]');
    var source = scope.querySelector('#pb-final-val');
    var pills = selector ? selector.querySelectorAll('[data-pb-offer-card]') : scope.querySelectorAll('.pb-sel-pill');
    if (!source || !pills.length) return;

    var unitPrice = readUnitPrice(scope);
    var userInteracted = false;

    var discountFor = function (qty, card) {
      var sourceCard = card || (selector && selector.querySelector('[data-pb-offer-card][data-qty="' + qty + '"]'));
      var parsed = sourceCard && sourceCard.dataset.discount ? parseFloat(sourceCard.dataset.discount) : NaN;
      if (!Number.isNaN(parsed) && parsed >= 0) return parsed;
      if (qty === 2) return 0.05;
      return qty >= 3 ? 0.10 : 0;
    };

    scope.addEventListener('click', function (event) {
      var pill = event.target.closest('[data-pb-offer-card], .pb-sel-pill');
      var stepper = event.target.closest('.pb-stepper-control');
      if (pill || stepper) {
        userInteracted = true;
        event.preventDefault();
      }

      if (pill) {
        var qty = pill.dataset.qty;
        if (!qty && pill.id) {
          var match = pill.id.match(/card-qty-(\d+)/);
          qty = match && match[1];
        }
        if (qty) {
          runOfferBurst(selector, event);
          update(qty, pill);
        }
      }

      if (stepper) {
        runOfferBurst(selector, event);
        var explicitStep = parseInt(stepper.dataset.pbStep, 10);
        var direction = !Number.isNaN(explicitStep)
          ? explicitStep
          : String(stepper.textContent || '').includes('-') || String(stepper.textContent || '').includes('−')
            ? -1
            : 1;
        update((parseInt(source.value, 10) || 1) + direction);
      }
    });

    var update = function (qty) {
      qty = Math.max(1, parseInt(qty, 10) || 1);
      window.CUSTOM_QUANTITY = qty;
      source.value = String(qty);

      pills.forEach(function (pill) {
        pill.classList.remove('active');
        pill.classList.remove('is-selected');
        if (pill.getAttribute('role') === 'radio') pill.setAttribute('aria-checked', 'false');
      });

      var activeId = qty === 1 ? 'card-qty-1' : qty === 2 ? 'card-qty-2' : 'card-qty-3';
      var active = scope.querySelector('#' + activeId);
      if (active) {
        active.classList.add('active');
        active.classList.add('is-selected');
        if (active.getAttribute('role') === 'radio') active.setAttribute('aria-checked', 'true');
      }

      if (unitPrice > 0) {
        var discount = discountFor(qty, active);
        var fullPrice = qty * unitPrice;
        var savings = fullPrice * discount;
        var finalPrice = fullPrice - savings;

        var originalContainer = scope.querySelector('#pb-original-container');
        var originalPrice = scope.querySelector('#pb-original-price');
        var divider = scope.querySelector('#pb-divider');
        var totalPrice = scope.querySelector('#pb-total-price');
        var savingsContainer = scope.querySelector('#pb-savings-container');
        var savingsAmount = scope.querySelector('#pb-savings-amount');

        if (originalContainer && divider) {
          originalContainer.style.display = discount > 0 ? 'flex' : 'none';
          divider.style.display = discount > 0 ? 'block' : 'none';
        }
        if (originalPrice) originalPrice.textContent = formatLei(fullPrice);
        if (totalPrice) totalPrice.textContent = formatLei(finalPrice);
        if (savingsContainer) savingsContainer.style.display = savings > 0 ? 'flex' : 'none';
        if (savingsAmount) savingsAmount.textContent = formatLei(savings);

        if (totalPrice && userInteracted && !prefersReducedMotion()) {
          totalPrice.classList.remove('pb-total-flash');
          void totalPrice.offsetWidth;
          totalPrice.classList.add('pb-total-flash');
        }
      }

      source.dispatchEvent(new Event('input', { bubbles: true }));
      source.dispatchEvent(new Event('change', { bubbles: true }));
    };

    if (typeof window.pbSetLogic !== 'function') {
      window.pbSetLogic = function (qty, event) {
        runOfferBurst(selector, event);
        update(qty);
      };
    }

    if (typeof window.pbManualStep !== 'function') {
      window.pbManualStep = function (delta) {
        update((parseInt(source.value, 10) || 1) + delta);
      };
    }

    if (typeof window.pbValidateInput !== 'function') {
      window.pbValidateInput = function (input) {
        update(input && input.value);
      };
    }

    var intendedDefault = source.getAttribute('value') || source.value || 1;
    update(intendedDefault);

    [320, 700].forEach(function (delay) {
      window.setTimeout(function () {
        if (!userInteracted && parseInt(source.getAttribute('value'), 10) > 1 && readOfferQuantity(scope) === 1) {
          update(intendedDefault);
        }
      }, delay);
    });
  }

  function syncQuantity(scope) {
    var form = scope.querySelector('form[data-type="add-to-cart-form"]');
    if (!form) return;

    var quantityInput = form.querySelector('input[name="quantity"]');
    if (!quantityInput) {
      quantityInput = document.createElement('input');
      quantityInput.type = 'hidden';
      quantityInput.name = 'quantity';
      form.appendChild(quantityInput);
    }

    var update = function () {
      quantityInput.value = String(readOfferQuantity(scope));
    };

    update();

    var source = scope.querySelector('#pb-final-val');
    if (source) {
      source.addEventListener('change', update);
      source.addEventListener('input', update);
    }

    scope.addEventListener('click', function (event) {
      if (event.target.closest('[data-pb-offer-card], .pb-sel-pill') || event.target.closest('.pb-stepper-control')) {
        window.setTimeout(update, 0);
      }
    });

    form.addEventListener('submit', update, true);
  }

  function initCtaPulse(productInfo, submit, stickyButton) {
    if (productInfo.dataset.pbCtaPulseReady === 'true') return;
    productInfo.dataset.pbCtaPulseReady = 'true';

    var mainPulseTargets = [submit].filter(Boolean);
    var stickyPulseTargets = [stickyButton].filter(Boolean);
    var targets = mainPulseTargets.concat(stickyPulseTargets);
    var pulseClass = 'pb-cta-pulse';
    var targetClass = 'pb-cta-pulse-target';
    var pulseDurationMs = 1700;
    var mainPulseIntervalMs = 6000;
    var stickyPulseIntervalMs = 15000;
    productInfo.dataset.pbCtaPulseIntervalMs = String(mainPulseIntervalMs);
    productInfo.dataset.pbStickyCtaPulseIntervalMs = String(stickyPulseIntervalMs);

    targets.forEach(function (button) {
      button.classList.add(targetClass);
    });

    mainPulseTargets.forEach(function (button) {
      if (button.querySelector('.pb-cta-shine')) return;
      var shine = document.createElement('span');
      shine.className = 'pb-cta-shine';
      shine.setAttribute('aria-hidden', 'true');
      button.appendChild(shine);
    });

    var prefersReducedMotion = function () {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    };

    var pulseTargets = function (pulseTargets) {
      if (prefersReducedMotion()) return;

      pulseTargets.forEach(function (button) {
        button.classList.remove(pulseClass);
      });

      void productInfo.offsetWidth;

      pulseTargets.forEach(function (button) {
        if (button.disabled || button.getAttribute('aria-disabled') === 'true') return;
        button.classList.add(pulseClass);
        window.setTimeout(function () {
          button.classList.remove(pulseClass);
        }, pulseDurationMs);
      });
    };

    var runMainPulse = function () {
      pulseTargets(mainPulseTargets);
    };

    var runStickyPulse = function () {
      pulseTargets(stickyPulseTargets);
    };

    window.pbTrustFunnelPulseCta = runMainPulse;
    productInfo.addEventListener('pb:trust-funnel:pulse-cta', function () {
      runMainPulse();
      runStickyPulse();
    });
    window.setTimeout(runMainPulse, 400);
    window.setInterval(runMainPulse, mainPulseIntervalMs);

    if (stickyPulseTargets.length) {
      window.setTimeout(runStickyPulse, 900);
      window.setInterval(runStickyPulse, stickyPulseIntervalMs);
    }
  }

  function styleStoreKey(property) {
    return 'pbTfOriginal' + property.replace(/-([a-z])/g, function (_, letter) {
      return letter.toUpperCase();
    });
  }

  function setTemporaryImportantStyle(element, property, value) {
    if (!element || !element.style) return;

    if (value) {
      var storeKey = styleStoreKey(property);
      var priorityKey = storeKey + 'Priority';

      if (!Object.prototype.hasOwnProperty.call(element.dataset, storeKey)) {
        element.dataset[storeKey] = element.style.getPropertyValue(property) || '__empty__';
        element.dataset[priorityKey] = element.style.getPropertyPriority(property) || '';
      }

      if (
        element.style.getPropertyValue(property) === value &&
        element.style.getPropertyPriority(property) === 'important'
      ) {
        return;
      }

      element.style.setProperty(property, value, 'important');
    } else {
      var originalKey = styleStoreKey(property);
      var originalPriorityKey = originalKey + 'Priority';
      var originalValue = element.dataset[originalKey];
      var originalPriority = element.dataset[originalPriorityKey] || '';

      if (originalValue && originalValue !== '__empty__') {
        if (
          element.style.getPropertyValue(property) !== originalValue ||
          element.style.getPropertyPriority(property) !== originalPriority
        ) {
          element.style.setProperty(property, originalValue, originalPriority);
        }
      } else if (element.style.getPropertyValue(property)) {
        element.style.removeProperty(property);
      }

      delete element.dataset[originalKey];
      delete element.dataset[originalPriorityKey];
    }
  }

  function syncBottomWidgets(shouldOffset) {
    var isMobile = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
    var sticky = document.querySelector('[data-pb-sticky-atc]');
    var stickyRect = sticky ? sticky.getBoundingClientRect() : null;
    var stickyBottomGap =
      stickyRect && stickyRect.height > 0 ? Math.max(0, window.innerHeight - stickyRect.bottom) : 8;
    var stickyStackHeight =
      stickyRect && shouldOffset ? Math.ceil(stickyRect.height + stickyBottomGap + 10) : 0;
    var widgetOffset =
      stickyRect && shouldOffset && isMobile ? Math.ceil(stickyRect.height + stickyBottomGap + 12) : 88;
    var offset = shouldOffset && isMobile ? widgetOffset + 'px' : '';
    var chatBottom = isMobile ? offset || '16px' : '';
    var chatRight = isMobile ? '16px' : '';
    var chat = document.getElementById('ShopifyChat');
    var shouldHideChat =
      isMobile &&
      (document.body.classList.contains('pb-tf-v1-primary-cta-visible') ||
        document.body.classList.contains('pb-tf-v1-initial-fold') ||
        document.body.classList.contains('pb-tf-v1-offer-visible'));

    document.body.classList.toggle('pb-tf-v1-sticky-visible', Boolean(stickyStackHeight));
    if (stickyStackHeight) {
      document.body.style.setProperty('--pb-tf-sticky-stack-height', stickyStackHeight + 'px');
    } else {
      document.body.style.removeProperty('--pb-tf-sticky-stack-height');
    }

    if (offset) {
      document.body.style.setProperty('--pb-tf-bottom-widget-offset', widgetOffset + 'px');
    } else {
      document.body.style.removeProperty('--pb-tf-bottom-widget-offset');
    }

    setTemporaryImportantStyle(chat, 'bottom', chatBottom);
    setTemporaryImportantStyle(chat, 'right', chatRight);
    setTemporaryImportantStyle(chat, 'visibility', shouldHideChat ? 'hidden' : '');
    setTemporaryImportantStyle(chat, 'opacity', shouldHideChat ? '0' : '');
    setTemporaryImportantStyle(chat, 'pointer-events', shouldHideChat ? 'none' : '');

    return Boolean(chat);
  }

  function syncShopifyChatBubble() {
    var chat = document.getElementById('ShopifyChat');
    if (!chat || !chat.shadowRoot) return false;

    var iconOnlyStyle = chat.shadowRoot.getElementById('pbTfChatIconOnlyStyle');

    if (document.querySelector('[data-pb-support-bubble]')) {
      if (iconOnlyStyle) iconOnlyStyle.remove();
      return true;
    }

    if (!iconOnlyStyle) {
      var style = document.createElement('style');
      style.id = 'pbTfChatIconOnlyStyle';
      style.textContent =
        '[data-spec="button-text"] { display: none !important; }' +
        '[data-spec="toggle-button"] {' +
        'width: 64px !important;' +
        'min-width: 64px !important;' +
        'height: 64px !important;' +
        'min-height: 64px !important;' +
        'padding: 0 !important;' +
        'border-radius: 999px !important;' +
        'align-items: center !important;' +
        'justify-content: center !important;' +
        'gap: 0 !important;' +
        'overflow: visible !important;' +
        '}' +
        '[data-spec="button-icon"] {' +
        'width: 32px !important;' +
        'height: 32px !important;' +
        'flex: 0 0 auto !important;' +
        '}' +
        '[data-spec="notification-badge"] {' +
        'top: -4px !important;' +
        'right: -4px !important;' +
        '}' +
        '.chat-app {' +
        'width: 76px !important;' +
        'height: 76px !important;' +
        'overflow: visible !important;' +
        '}';
      chat.shadowRoot.appendChild(style);
    }

    return true;
  }

  function initShopifyChatBubbleGuard(productInfo) {
    if (productInfo.dataset.pbChatBubbleReady === 'true') return;
    productInfo.dataset.pbChatBubbleReady = 'true';

    var schedule = function () {
      window.requestAnimationFrame(syncShopifyChatBubble);
    };

    schedule();
    window.setTimeout(syncShopifyChatBubble, 500);
    window.setTimeout(syncShopifyChatBubble, 1500);
    window.setTimeout(syncShopifyChatBubble, 3000);

    if ('MutationObserver' in window) {
      new MutationObserver(schedule).observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  }

  function initStickyAtc(productInfo) {
    var sticky = productInfo.querySelector('[data-pb-sticky-atc]');
    var stickyButton = productInfo.querySelector('[data-pb-sticky-submit]');
    var submit = productInfo.querySelector('.product-form__submit');
    if (!sticky || !stickyButton || !submit) return;
    var isStickyVisible = null;
    var bottomWidgetSyncTimer = null;

    var syncDisabled = function () {
      stickyButton.disabled = submit.disabled || submit.getAttribute('aria-disabled') === 'true';
      sticky.setAttribute('aria-hidden', sticky.classList.contains('is-visible') ? 'false' : 'true');
    };

    stickyButton.addEventListener('click', function () {
      syncDisabled();
      if (!stickyButton.disabled) submit.click();
    });

    var setStickyVisibility = function (shouldShow, forceSync) {
      shouldShow = Boolean(shouldShow);
      document.body.classList.toggle('pb-tf-v1-primary-cta-visible', !shouldShow);
      if (isStickyVisible === shouldShow && !forceSync) {
        syncBottomWidgets(shouldShow);
        syncDisabled();
        return;
      }

      isStickyVisible = shouldShow;
      sticky.classList.toggle('is-visible', shouldShow);
      var widgetsReady = syncBottomWidgets(shouldShow);

      if (bottomWidgetSyncTimer) window.clearTimeout(bottomWidgetSyncTimer);
      if (!widgetsReady) {
        bottomWidgetSyncTimer = window.setTimeout(function () {
          bottomWidgetSyncTimer = null;
          syncBottomWidgets(shouldShow);
        }, 250);
      }

      syncDisabled();
    };

    var updateVisibility = function (forceSync) {
      var rect = submit.getBoundingClientRect();
      var isMobile = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
      var offerVisible = document.body.classList.contains('pb-tf-v1-offer-visible');
      var shouldShowSticky = rect.bottom < 0 || rect.top > window.innerHeight;
      if (isMobile && offerVisible) shouldShowSticky = false;

      document.body.classList.toggle('pb-tf-v1-initial-fold', window.scrollY < 96);
      setStickyVisibility(shouldShowSticky, Boolean(forceSync));
    };

    if ('MutationObserver' in window) {
      new MutationObserver(syncDisabled).observe(submit, {
        attributes: true,
        attributeFilter: ['disabled', 'aria-disabled', 'class']
      });
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function () {
          updateVisibility(true);
        },
        { threshold: 0.2 }
      );

      observer.observe(submit);
    }

    window.addEventListener('scroll', updateVisibility, { passive: true });
    window.addEventListener('resize', function () {
      updateVisibility(true);
    });
    productInfo.addEventListener('pb:trust-funnel:offer-visibility', function () {
      updateVisibility(true);
    });
    initCtaPulse(productInfo, submit, stickyButton);
    updateVisibility();
    [350, 900, 1800].forEach(function (delay) {
      window.setTimeout(function () {
        updateVisibility(true);
      }, delay);
    });
  }

  function initMobileGallery(productInfo) {
    var gallery = productInfo.querySelector('media-gallery');
    if (!gallery || gallery.dataset.pbMobileGalleryReady === 'true') return;

    var viewer = gallery.querySelector('[id^="GalleryViewer"]');
    var slider = gallery.querySelector('[id^="Slider-Gallery"]');
    var thumbnails = gallery.querySelector('[id^="GalleryThumbnails"]');
    var thumbList = gallery.querySelector('[id^="Slider-Thumbnails"]');
    if (!viewer || !slider) return;

    gallery.dataset.pbMobileGalleryReady = 'true';

    var getSlides = function () {
      return Array.prototype.slice.call(slider.children).filter(function (child) {
        return child.matches && child.matches('[data-media-id]');
      });
    };

    var ensureMobileThumbnails = function () {
      if (thumbnails && thumbList) return true;

      var slides = getSlides();
      if (slides.length < 2) return false;

      thumbnails = document.createElement('div');
      thumbnails.id = 'GalleryThumbnails-' + Date.now();
      thumbnails.className = 'thumbnail-slider slider-mobile-gutter quick-add-hidden pb-tf-generated-thumbnails';

      thumbList = document.createElement('ul');
      thumbList.id = 'Slider-Thumbnails-' + Date.now();
      thumbList.className = 'thumbnail-list list-unstyled slider slider--mobile';

      slides.forEach(function (slide, index) {
        var mediaId = slide.dataset.mediaId;
        var sourceImage = slide.querySelector('.product__media img');
        if (!mediaId || !sourceImage) return;

        var item = document.createElement('li');
        item.className = 'thumbnail-list__item slider__slide';
        item.dataset.target = mediaId;
        item.dataset.mediaPosition = String(index + 1);

        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'thumbnail global-media-settings global-media-settings--no-shadow';
        button.setAttribute('aria-label', 'Încarcă imaginea ' + (index + 1));
        button.setAttribute('aria-controls', viewer.id);
        if (index === 0) button.setAttribute('aria-current', 'true');

        var image = document.createElement('img');
        image.loading = 'lazy';
        image.alt = sourceImage.alt || '';
        image.src = sourceImage.currentSrc || sourceImage.src;
        if (sourceImage.srcset) image.srcset = sourceImage.srcset;
        image.sizes = '58px';

        button.appendChild(image);
        item.appendChild(button);
        thumbList.appendChild(item);
      });

      if (!thumbList.children.length) return false;

      thumbnails.appendChild(thumbList);
      viewer.insertAdjacentElement('afterend', thumbnails);
      return true;
    };

    if (!ensureMobileThumbnails()) return;

    var getThumb = function (mediaId) {
      return thumbnails.querySelector('[data-target="' + mediaId + '"]');
    };

    var applyMobileSlideStyles = function () {
      var mobile = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;

      getSlides().forEach(function (slide) {
        if (mobile) {
          slide.style.setProperty('display', 'block', 'important');
          slide.style.setProperty('flex', '0 0 calc(100% - var(--pb-tf-gallery-peek))', 'important');
          slide.style.setProperty('width', 'calc(100% - var(--pb-tf-gallery-peek))', 'important');
          slide.style.setProperty('max-width', 'calc(100% - var(--pb-tf-gallery-peek))', 'important');
          slide.style.setProperty('scroll-snap-align', 'start');
        } else {
          slide.style.removeProperty('display');
          slide.style.removeProperty('flex');
          slide.style.removeProperty('width');
          slide.style.removeProperty('max-width');
          slide.style.removeProperty('scroll-snap-align');
        }
      });
    };

    var setActive = function (slide, shouldScrollThumb) {
      if (!slide) return;
      var mediaId = slide.dataset.mediaId;
      if (!mediaId) return;

      getSlides().forEach(function (item) {
        item.classList.toggle('is-active', item === slide);
      });

      thumbnails.querySelectorAll('button').forEach(function (button) {
        button.removeAttribute('aria-current');
      });

      var activeThumb = getThumb(mediaId);
      var activeButton = activeThumb && activeThumb.querySelector('button');
      if (activeButton) activeButton.setAttribute('aria-current', true);

      if (shouldScrollThumb && activeThumb) {
        var thumbLeft = activeThumb.offsetLeft;
        var thumbRight = thumbLeft + activeThumb.offsetWidth;
        var visibleLeft = thumbList.scrollLeft;
        var visibleRight = visibleLeft + thumbList.clientWidth;

        if (thumbLeft < visibleLeft || thumbRight > visibleRight) {
          thumbList.scrollTo({ left: Math.max(0, thumbLeft - 8), behavior: 'smooth' });
        }
      }
    };

    var syncFromScroll = function () {
      var slides = getSlides();
      if (!slides.length) return;

      var viewportCenter = slider.scrollLeft + slider.clientWidth / 2;
      var active = slides.reduce(function (closest, slide) {
        var slideCenter = slide.offsetLeft + slide.clientWidth / 2;
        var distance = Math.abs(viewportCenter - slideCenter);
        return !closest || distance < closest.distance ? { slide: slide, distance: distance } : closest;
      }, null);

      setActive(active && active.slide, true);
    };

    var rafId = 0;
    var requestSync = function () {
      if (rafId) return;
      rafId = window.requestAnimationFrame(function () {
        rafId = 0;
        syncFromScroll();
      });
    };

    slider.addEventListener('scroll', requestSync, { passive: true });
    window.addEventListener('resize', function () {
      applyMobileSlideStyles();
      requestSync();
    });

    thumbnails.querySelectorAll('[data-target]').forEach(function (thumb) {
      var button = thumb.querySelector('button');
      if (!button) return;

      button.addEventListener('click', function () {
        var slide = slider.querySelector('[data-media-id="' + thumb.dataset.target + '"]');
        if (!slide) return;

        window.setTimeout(function () {
          slider.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
          setActive(slide, true);
        }, 0);
      });
    });

    if (thumbList && thumbList.dataset.pbWheelScrollReady !== 'true') {
      thumbList.dataset.pbWheelScrollReady = 'true';
      thumbList.addEventListener(
        'wheel',
        function (event) {
          if (thumbList.scrollWidth <= thumbList.clientWidth + 4) return;

          var delta = Math.abs(event.deltaX) > Math.abs(event.deltaY) ? event.deltaX : event.deltaY;
          if (!delta) return;

          event.preventDefault();
          thumbList.scrollBy({ left: delta, behavior: 'smooth' });
        },
        { passive: false }
      );
    }

    applyMobileSlideStyles();
    requestSync();
  }

  function initAnnouncementRotator() {
    document.querySelectorAll('.pbab-static').forEach(function (wrap) {
      if (wrap.dataset.pbRotatorReady === 'true') return;
      var slides = Array.prototype.slice.call(wrap.querySelectorAll('.pbab-slide'));
      if (slides.length < 2) return;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      wrap.dataset.pbRotatorReady = 'true';
      var currentIndex = slides.findIndex(function (slide) {
        return slide.classList.contains('is-active');
      });
      if (currentIndex < 0) currentIndex = 0;

      window.setInterval(function () {
        slides[currentIndex].classList.remove('is-active');
        currentIndex = (currentIndex + 1) % slides.length;
        slides[currentIndex].classList.add('is-active');
      }, 4000);
    });
  }

  function initOfferVisibilityGuard(productInfo) {
    var offer = productInfo.querySelector('[data-pb-offer-selector]');
    if (!offer || offer.dataset.pbOfferVisibilityReady === 'true') return;
    offer.dataset.pbOfferVisibilityReady = 'true';

    var lastVisible = null;

    var sync = function () {
      var rect = offer.getBoundingClientRect();
      var isVisible = rect.bottom > 0 && rect.top < window.innerHeight;
      if (lastVisible === isVisible) return;

      lastVisible = isVisible;
      document.body.classList.toggle('pb-tf-v1-offer-visible', isVisible);
      productInfo.dispatchEvent(new CustomEvent('pb:trust-funnel:offer-visibility', { detail: { visible: isVisible } }));
      syncBottomWidgets(document.body.classList.contains('pb-tf-v1-sticky-visible'));
    };

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(sync, { threshold: [0, 0.01, 0.5, 1] });
      observer.observe(offer);
    }

    window.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
    [300, 900, 1800].forEach(function (delay) {
      window.setTimeout(sync, delay);
    });
  }

  function initBenefitSystem(productInfo) {
    productInfo.querySelectorAll('[data-pb-benefit-system]').forEach(function (system) {
      if (system.dataset.pbBenefitReady === 'true') return;
      system.dataset.pbBenefitReady = 'true';

      var cards = Array.prototype.slice.call(system.querySelectorAll('[data-pb-benefit-card]'));
      var panels = Array.prototype.slice.call(system.querySelectorAll('[data-pb-benefit-panel]'));
      if (!cards.length || !panels.length) return;

      var activate = function (key) {
        cards.forEach(function (card) {
          var active = card.dataset.pbBenefitCard === key;
          card.classList.toggle('is-active', active);
          card.setAttribute('aria-expanded', active ? 'true' : 'false');
        });

        panels.forEach(function (panel) {
          var active = panel.dataset.pbBenefitPanel === key;
          panel.classList.toggle('is-active', active);
          panel.hidden = !active;
        });
      };

      cards.forEach(function (card) {
        card.addEventListener('click', function () {
          activate(card.dataset.pbBenefitCard);
        });
      });
    });
  }

  function initProofToggles(productInfo) {
    var stack = productInfo.querySelector('[data-pb-proof-stack]');
    if (!stack || stack.dataset.pbProofReady === 'true') return;
    stack.dataset.pbProofReady = 'true';

    var chips = Array.prototype.slice.call(stack.querySelectorAll('[data-pb-proof-toggle]'));
    var panels = Array.prototype.slice.call(stack.querySelectorAll('[data-pb-proof-panel]'));

    var syncProofState = function () {
      var hasOpenPanel = panels.some(function (panel) {
        return !panel.hidden && panel.classList.contains('is-active');
      });
      stack.classList.toggle('is-open', hasOpenPanel);
    };

    var closeProof = function () {
      chips.forEach(function (chip) {
        chip.classList.remove('is-active');
        if (chip.hasAttribute('aria-expanded')) chip.setAttribute('aria-expanded', 'false');
      });

      panels.forEach(function (panel) {
        panel.classList.remove('is-active');
        panel.hidden = true;
      });

      syncProofState();
    };

    var openProof = function (key, shouldScroll) {
      if (!key) return;

      chips.forEach(function (chip) {
        var active = chip.dataset.pbProofToggle === key;
        chip.classList.toggle('is-active', active);
        if (chip.hasAttribute('aria-expanded')) chip.setAttribute('aria-expanded', active ? 'true' : 'false');
      });

      panels.forEach(function (panel) {
        var active = panel.dataset.pbProofPanel === key;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });

      syncProofState();

      if (shouldScroll) {
        window.setTimeout(function () {
          stack.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 0);
      }
    };

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        if (chip.classList.contains('is-active')) {
          closeProof();
          return;
        }

        openProof(chip.dataset.pbProofToggle, false);
      });
    });

    syncProofState();

    productInfo.pbTrustFunnelOpenProof = openProof;
    window.pbTrustFunnelOpenProof = openProof;
  }

  function initGalleryProofTrigger(productInfo) {
    var triggers = productInfo.querySelectorAll('[data-pb-gallery-proof-trigger]');
    if (!triggers.length) return;

    triggers.forEach(function (trigger) {
      if (trigger.dataset.pbGalleryProofReady === 'true') return;
      trigger.dataset.pbGalleryProofReady = 'true';

      trigger.addEventListener('click', function () {
        var target = trigger.dataset.pbProofTarget || 'lab';
        if (typeof productInfo.pbTrustFunnelOpenProof === 'function') {
          productInfo.pbTrustFunnelOpenProof(target, true);
        }
      });
    });
  }

  function initCookieConsentStacking(productInfo) {
    if (productInfo.dataset.pbCookieStackingReady === 'true') return;
    productInfo.dataset.pbCookieStackingReady = 'true';
    var activeManagedPanels = [];
    var activeObservedPanels = [];
    var lastStack = null;
    var applyFrame = null;
    var globalConsentState =
      window.PBConsentSurface && typeof window.PBConsentSurface.getState === 'function'
        ? window.PBConsentSurface.getState()
        : { visible: false, kind: null, height: 0, bottomGap: 0, lift: 0 };

    var selector =
      '[id*="cookie" i], [class*="cookie" i], [id*="consent" i], [class*="consent" i], [id*="gdpr" i], [class*="gdpr" i]';

    var isVisibleOverlay = function (element) {
      if (!element || element === document.body || element === document.documentElement) return false;
      var rect = element.getBoundingClientRect();
      if (rect.width < 180 || rect.height < 36) return false;
      if (rect.bottom < 0 || rect.top > window.innerHeight) return false;
      var style = window.getComputedStyle(element);
      if (style.display === 'none' || style.visibility === 'hidden' || parseFloat(style.opacity || '1') === 0) return false;
      return style.position === 'fixed' || style.position === 'sticky' || rect.bottom > window.innerHeight - 220;
    };

    var collectPanels = function () {
      var managedPanels = Array.prototype.slice.call(document.querySelectorAll(selector)).filter(function (panel) {
        if (panel.id === 'ShopifyChat' || panel.closest && panel.closest('[data-pb-sticky-atc]')) return false;
        return isVisibleOverlay(panel);
      });
      var observedPanels = managedPanels.slice();

      return { managedPanels: managedPanels, observedPanels: observedPanels };
    };

    var restorePanel = function (panel) {
      if (!panel || panel.getAttribute('data-pb-tf-cookie-panel') !== 'true') return;
      panel.removeAttribute('data-pb-tf-cookie-panel');
      setTemporaryImportantStyle(panel, 'z-index', '');
      setTemporaryImportantStyle(panel, 'max-height', '');
      setTemporaryImportantStyle(panel, 'overflow', '');
      setTemporaryImportantStyle(panel, 'overflow-x', '');
      setTemporaryImportantStyle(panel, 'overflow-y', '');
      setTemporaryImportantStyle(panel, 'bottom', '');
    };

    var setBodyVariable = function (property, value) {
      if (document.body.style.getPropertyValue(property) === value) return;
      if (value) {
        document.body.style.setProperty(property, value);
      } else {
        document.body.style.removeProperty(property);
      }
    };

    var clearState = function () {
      var wasVisible =
        activeObservedPanels.length > 0 ||
        lastStack !== null ||
        document.body.classList.contains('pb-tf-v1-consent-visible');
      if (document.body.classList.contains('pb-tf-v1-consent-visible')) {
        document.body.classList.remove('pb-tf-v1-consent-visible');
      }
      setBodyVariable('--pb-tf-consent-panel-height', '');
      setBodyVariable('--pb-tf-consent-panel-bottom', '');
      setBodyVariable('--pb-tf-consent-lift', '');
      activeManagedPanels.forEach(restorePanel);
      activeManagedPanels = [];
      activeObservedPanels = [];
      lastStack = null;
      if (wasVisible) {
        document.dispatchEvent(new CustomEvent('pb:trust-funnel:consent-visibility', { detail: { visible: false } }));
      }
    };

    var measureStack = function (panels) {
      if (!panels.length) return null;

      var box = panels.reduce(
        function (memo, panel) {
          var rect = panel.getBoundingClientRect();
          memo.top = Math.min(memo.top, rect.top);
          memo.bottom = Math.max(memo.bottom, rect.bottom);
          return memo;
        },
        { top: Number.POSITIVE_INFINITY, bottom: Number.NEGATIVE_INFINITY }
      );

      var top = Math.max(0, Math.min(window.innerHeight, box.top));
      var bottom = Math.max(0, Math.min(window.innerHeight, box.bottom));
      var height = Math.ceil(Math.max(0, bottom - top));
      var bottomGap = Math.ceil(Math.max(0, window.innerHeight - bottom));

      if (!height) return null;
      return {
        height: height,
        bottomGap: bottomGap,
        lift: height + bottomGap + 12
      };
    };

    var apply = function () {
      var panelState = collectPanels();
      var managedPanels = panelState.managedPanels;
      var observedPanels = panelState.observedPanels;
      var stack = globalConsentState && globalConsentState.visible
        ? {
            height: Number(globalConsentState.height) || 0,
            bottomGap: Number(globalConsentState.bottomGap) || 0,
            lift: Number(globalConsentState.lift) || 0
          }
        : measureStack(observedPanels);

      if (!stack) {
        clearState();
        return;
      }

      var nextObservedPanelSet = new Set(observedPanels);
      var panelsChanged =
        activeObservedPanels.length !== observedPanels.length ||
        activeObservedPanels.some(function (panel) {
          return !nextObservedPanelSet.has(panel);
        });
      var stackChanged =
        !lastStack ||
        lastStack.height !== stack.height ||
        lastStack.bottomGap !== stack.bottomGap ||
        lastStack.lift !== stack.lift;
      var nextManagedPanelSet = new Set(managedPanels);
      activeManagedPanels.forEach(function (panel) {
        if (!nextManagedPanelSet.has(panel)) restorePanel(panel);
      });

      managedPanels.forEach(function (panel) {
        if (panel.getAttribute('data-pb-tf-cookie-panel') !== 'true') {
          panel.setAttribute('data-pb-tf-cookie-panel', 'true');
        }
        setTemporaryImportantStyle(panel, 'z-index', '2147482600');
        setTemporaryImportantStyle(panel, 'max-height', 'min(46vh, 420px)');
        setTemporaryImportantStyle(panel, 'overflow-x', 'hidden');
        setTemporaryImportantStyle(panel, 'overflow-y', 'auto');
        setTemporaryImportantStyle(panel, 'bottom', 'max(10px, env(safe-area-inset-bottom))');
      });

      activeManagedPanels = managedPanels;
      activeObservedPanels = observedPanels;
      if (!document.body.classList.contains('pb-tf-v1-consent-visible')) {
        document.body.classList.add('pb-tf-v1-consent-visible');
      }
      setBodyVariable('--pb-tf-consent-panel-height', stack.height + 'px');
      setBodyVariable('--pb-tf-consent-panel-bottom', stack.bottomGap + 'px');
      setBodyVariable('--pb-tf-consent-lift', stack.lift + 'px');

      if (panelsChanged || stackChanged) {
        document.dispatchEvent(
          new CustomEvent('pb:trust-funnel:consent-visibility', {
            detail: { visible: true, height: stack.height, bottomGap: stack.bottomGap, lift: stack.lift }
          })
        );
      }
      lastStack = stack;
    };

    var scheduleApply = function () {
      if (applyFrame !== null) return;
      applyFrame = window.requestAnimationFrame(function () {
        applyFrame = null;
        apply();
      });
    };

    apply();
    window.setTimeout(scheduleApply, 500);
    window.setTimeout(scheduleApply, 1500);
    window.addEventListener('scroll', scheduleApply, { passive: true });
    window.addEventListener('resize', scheduleApply);
    document.addEventListener('pb:consent-surface-visibility', function (event) {
      globalConsentState = event && event.detail
        ? Object.assign({}, event.detail)
        : { visible: false, kind: null, height: 0, bottomGap: 0, lift: 0 };
      scheduleApply();
    });

    if ('MutationObserver' in window) {
      new MutationObserver(scheduleApply).observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'class', 'open']
      });
    }
  }

  function fitDesktopProductTitle(productInfo) {
    if (!productInfo || productInfo.dataset.pbDesktopTitleFitReady === 'true') return;
    productInfo.dataset.pbDesktopTitleFitReady = 'true';

    var title = productInfo.querySelector('.pb-tf-v1 .product__title h1');
    if (!title) return;

    var fit = function () {
      if (!window.matchMedia || !window.matchMedia('(min-width: 990px)').matches) {
        title.style.removeProperty('--pb-tf-desktop-title-size');
        return;
      }

      var maxSize = 36;
      var minSize = 20;
      var size = maxSize;

      title.style.setProperty('--pb-tf-desktop-title-size', size + 'px');

      for (var i = 0; i < 18; i += 1) {
        var computed = window.getComputedStyle(title);
        var lineHeight = parseFloat(computed.lineHeight) || size * 1.06;
        var maxHeight = Math.ceil(lineHeight * 2 + 2);

        if (title.scrollHeight <= maxHeight || size <= minSize) break;

        size -= 1;
        title.style.setProperty('--pb-tf-desktop-title-size', size + 'px');
      }
    };

    var scheduleFit = function () {
      window.requestAnimationFrame(fit);
    };

    fit();
    window.addEventListener('resize', scheduleFit, { passive: true });
    window.addEventListener('load', scheduleFit, { once: true });

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(scheduleFit).catch(function () {});
    }
  }

  function initHeaderShopMega() {
    if (document.body.dataset.pbHeaderShopMegaReady === 'true') return;
    document.body.dataset.pbHeaderShopMegaReady = 'true';

    var item = document.querySelector('.pb-header-shop-menu-item');
    var panel = item && item.querySelector('.pb-header-shop-mega');
    var trigger = item && item.querySelector('summary, a');
    if (!item || !panel || !trigger) return;

    var align = function () {
      panel.style.removeProperty('--pb-header-shop-mega-left');
    };

    item.addEventListener('pointerenter', align, { passive: true });
    item.addEventListener('focusin', align);
    item.addEventListener('toggle', align, true);
    window.addEventListener('resize', align, { passive: true });
    window.addEventListener('scroll', align, { passive: true });
    align();
  }

  function init(root) {
    var productInfo = getScope(root);
    if (!productInfo || productInfo.dataset.pbTrustFunnelReady === 'true') return;
    productInfo.dataset.pbTrustFunnelReady = 'true';
    document.body.classList.add('pb-trust-funnel-v1-active');
    ensureOfferController(productInfo);
    syncQuantity(productInfo);
    initOfferVisibilityGuard(productInfo);
    initBenefitSystem(productInfo);
    initProofToggles(productInfo);
    initGalleryProofTrigger(productInfo);
    initCookieConsentStacking(productInfo);
    initShopifyChatBubbleGuard(productInfo);
    initMobileGallery(productInfo);
    fitDesktopProductTitle(productInfo);
    initHeaderShopMega();
    initAnnouncementRotator();
    initStickyAtc(productInfo);
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('product-info').forEach(init);
  });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target && event.target.querySelector('product-info'));
  });
})();
